import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { NomenclatureState } from './state';

const defaultState: NomenclatureState = {
  non_conv_honoraria: [],
};

export const nomenclatureModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
